import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.DealerClaimType.Save.IRequest;
type Response = Api.Core.DealerClaimType.Save.IResponse;
type Headers = Api.Core.DealerClaimType.Save.IHeaders;
const saveApiDealerClaimTypePath = '/api/DealerManagement/DealerClaimType';
export default async function dealerClaimTypeSaveApi(body: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    url: createPathFromRoute(saveApiDealerClaimTypePath, null, null),
    method: body?.id ? HttpMethod.put : HttpMethod.post,
    body: body,
    headers: getDefaultHeaders(),
  });
}
